// src/services/serviceService.js
import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);

// Lấy danh sách dịch vụ cho customer (với parent-child structure)
export const getServicesForCustomer = async (params = {}) => {
  try {
    const response = await apiClient.get("/service/customer", { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching services for customer:', error);
    throw error;
  }
};

// Lấy tất cả dịch vụ với pagination và filter (Admin)
export const getServices = async (params = {}) => {
  try {
    const response = await apiClient.get("/service", { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

// Lấy dịch vụ theo ID (với children)
export const getServiceById = async (id) => {
  try {
    const response = await apiClient.get(`/service/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service:', error);
    throw error;
  }
};

// Lấy dịch vụ theo slug (với children)
export const getServiceBySlug = async (slug) => {
  try {
    const response = await apiClient.get(`/service/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service by slug:', error);
    throw error;
  }
};

// Tạo dịch vụ mới (Admin only)
export const createService = async (serviceData) => {
  try {
    const response = await apiClient.post('/service', serviceData);
    return response.data;
  } catch (error) {
    console.error('Error creating service:', error);
    throw error;
  }
};

// Cập nhật dịch vụ (Admin only)
export const updateService = async (id, serviceData) => {
  try {
    const response = await apiClient.put(`/service/${id}`, serviceData);
    return response.data;
  } catch (error) {
    console.error('Error updating service:', error);
    throw error;
  }
};

// Xóa dịch vụ (Admin only)
export const deleteService = async (id) => {
  try {
    const response = await apiClient.delete(`/service/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting service:', error);
    throw error;
  }
};

